import React from 'react';
import { Outlet } from 'react-router';

import { Loader } from '@mantine/core';

import { useAuth } from 'hooks/useAuth';
import { useCanAccessNavItem } from 'hooks/useCanAccessNavItem';

import { MANAGE_MENU } from 'scopes/nav';

import { ErrorBoundaryUnauthorizedError } from 'errorBoundary/errors';

export default function MenuManagementLayout() {
  const { user: chownowUser, cubohUser } = useAuth();
  const canAccessNavItem = useCanAccessNavItem();

  if (!chownowUser && !cubohUser) return <Loader />;

  if (!canAccessNavItem(MANAGE_MENU)) {
    throw new ErrorBoundaryUnauthorizedError('Menu Editor');
  }

  return <Outlet />;
}
